import { Tag } from "./tag";

export class MessagePreview
{
	public id: string;
	public senderJurisdictionId: string;
	public recipientJurisdictionId: string;
	public senderId: string;
	public senderType: string;
	public recipientId: string;
	public recipientType: string;
	public subject: string;
	public body: string;
	public sentSecondsFromEpoch: number;
	public isPublic: boolean;
	public isCollect: boolean;
	public isPaid: boolean;
	public isApproved: boolean;
	public isRejected: boolean;
	public senderFullName: string;
	public recipientFullName: string;
	public senderBookingNumber: string;
	public recipientBookingNumber: string;
	public senderCivilianEmail: string;
	public recipientCivilianEmail: string;
	public openedSecondsFromEpoch: number;
	public creditsUsed: number;
	public wasAutoApproved: boolean;
	public brokePublicRule: boolean;
	public containsPhoto: boolean;

	// UI usage
	public isPrivateView: boolean;
}

export interface ModerationLabel {
    confidence: number;
    id: string;
    name: string;
    parentName: string;
    taxonomyLevel: number;
}

export class MessagePhoto
{
	public id: string;
	public url: string;
	public type: string;
	public filename: string;
	public fileType: string;
	public labels: ModerationLabel[];
}

export class MessageCost
{
	public costPerMessage: number;
	public costPerPhoto: number;
	public costPerDiscountedPhoto: number;
	public discountPhotosAfterX: number;
	public totalMessageCost: number;
}

export class MessageDraft
{
	public id: string;
	public recipientId: string;
	public subject: string;
	public text: string;
	public photos: MessagePhoto[];
	public senderUserType: string;
	public latitude: number;
	public longitude: number;
}

export class StaffMessageDraft
{
	public id: string;
	public recipientUserId: string;
	public senderUserId: string;
	public subject: string;
	public text: string;
	public photos: MessagePhoto[];
	public scannedImages: MessagePhoto[];
	public senderUserType: string;
	public recipientUserType: string;

	constructor(id: string, recipientUserId: string, senderUserId: string,
		subject: string, text: string, photos: MessagePhoto[], scannedImages: MessagePhoto[],
		senderUserType: string, recipientUserType: string)
	{
		this.id = id;
		this.recipientUserId = recipientUserId;
		this.senderUserId = senderUserId;
		this.subject = subject;
		this.text = text;
		this.photos = photos;
		this.scannedImages = scannedImages;
		this.senderUserType = senderUserType;
		this.recipientUserType = recipientUserType;
	}
}

export class MessageDraftSend
{
	public id: string;
	public recipientId: string;
	public subject: string;
	public text: string;
	public photos: MessagePhoto[];
	public isCollect: boolean;

	constructor (messageDraft: MessageDraft, isCollect: boolean)
	{
		this.id = messageDraft.id;
		this.recipientId = messageDraft.recipientId;
		this.subject = messageDraft.subject;
		this.text = messageDraft.text;
		this.photos = messageDraft.photos;
		this.isCollect = isCollect;
	}
}

export class MessageRule
{
	public id: string;
	public name: string;
	public messageId: string;
	public ruleId: string;
	public subjectText: string;
	public bodyText: string;
	public senderIsFlagged: boolean;
	public recipientIsFlagged: boolean;
	public visible: boolean;
}

export class PrivateRuleApproval
{
	public messageId: string;
	public ruleId: string;
	public approvedInstant: number;
	public approvedByUserStaffId: string;
	public rejectedInstant: number;
	public rejectedByUserStaffId: string;
}

export class MessageDetails
{
	public id: string;
	public senderJurisdictionId: string;
	public recipientJurisdictionId: string;
	public senderId: string;
	public senderType: string;
	public recipientId: string;
	public recipientType: string;
	public subject: string;
	public body: string;
	public sentSecondsFromEpoch: number;
	public isPublic: boolean;
	public isCollect: boolean;
	public isPaid: boolean;
	public latitude: number;
	public longitude: number;
	public senderFullName: string;
	public senderEmailOrBookingNumber: string;
	public recipientFullName: string;
	public recipientEmailOrBookingNumber: string;
	public senderTags: Tag[];
	public recipientTags: Tag[];
	public senderBookingNumber: string;
	public recipientBookingNumber: string;
	public senderCivilianEmail: string;
	public recipientCivilianEmail: string;
	public messageRules: MessageRule[];
	public photos: MessagePhoto[];
	public scannedImages: MessagePhoto[];
	public approvalSecondsFromEpoch: number;
	public rejectedSecondsFromEpoch: number;
	public approvedByFirstName: string;
	public approvedByLastName: string;
	public approvedByFullName: string;
	public rejectedByFirstName: string;
	public rejectedByLastName: string;
	public rejectedByFullName: string;
	public pendingUsername: string;
	public pendingFirstName: string;
	public pendingLastName: string;
	public recipientDisplayValue: string;
	public brokePublicRule: boolean;
	public containsPhoto: boolean;
	public privateRuleApprovals: PrivateRuleApproval[];
	public senderBillingAddress: string;
	public recipientBillingAddress: string;
	public confidence: number;
	public senderHasBeenReleased: boolean;
}
